module.exports = __webpack_public_path__ + "img/grade1.5953bd1c.png";